<template>
    <div class="compare-card compare-card--legend">
        <div class="compare-card__design">
            <div class="compare-card__item-label">Все размеры в мм</div>
            <div class="compare-filter">
                <input class="compare-filter__input" type="checkbox" id="compare-filter" v-model="highlight">
                <label class="compare-filter__label" for="compare-filter">Различающиеся характеристики <span class="switch"></span></label>
            </div>
        </div>
        <div class="compare-card__bottom">
            <div class="compare-card__list">
                <div v-for="param in currentCategoryParams" :key="param.id" class="compare-card__item">
                    <div class="compare-card__item-label">{{ param.name || ' ' }}</div>
                    <div class="compare-card__item-text"> </div>
                </div>
            </div>
            <div class="compare-card__list">
                <div class="compare-card__list-title">Загрузки</div>
                <div class="product-docs"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
    name: "CompareList",
    props: {
        categoryId: {
            type: String,
            default: null,
        }
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState({
            categories: state => state.categories,
            productsList: state => state.productsList,
        }),
        currentCategoryParams() {
            if (this.categoryId) {
                return this.categories.find(i => i.ID === this.categoryId).items[0].params
            } else {
                return this.productsList[0].params
            }
        },
        highlight: {
            get() {
                return this.$store.state.highlight
            },
            set(value) {
                this.setHighlight({val: value})
            }
        }
    },
    methods: {
        ...mapMutations({
            setHighlight: 'toggleHighlight'
        })
    }
}
</script>

<style scoped>

</style>